import React from 'react';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = ({ pieData }) => {
  const options = {
    responsive: true
  };

  return <Pie data={pieData} options={options} />;
};

export default PieChart;
